import svg4everybody from 'svg4everybody';
svg4everybody();

import './_vendor/_swiper.min';
import './_vendor/_marquee.min';
import './_vendor/_jquery-validation';
import './_vendor/_inputmask.bundle.min';
import './_vendor/_isotope.pkgd';
import './_vendor/_packery-mode.pkgd';
import './_vendor/_jquery.mCustomScrollbar.min';
import './_vendor/jQuery-One-Page-Nav.js';
